import { PlanningTypes } from 'pages/admin/demand/planning/context/types/contextPrevision.type';
import { MONTH_NAMES_PT_BR } from 'utils/functions/dateUtils';

import { PLANNING_CONSTANTS } from '../constants/planningConstants';
import { IFilterHierarchy } from '../types/planning.types';

export interface IForecastByLevelCycleMonth {
	label: string;
	dataFormatted: string;
	date: Date;
}

export const formatBrazilianNumber = (
	value: number | null | undefined,
	digits: number = 2
): string => {
	if (value === null || value === undefined) return '';
	return value.toLocaleString('pt-BR', {
		minimumFractionDigits: digits,
		maximumFractionDigits: digits,
	});
};

export function generateCycleMonths(
	cycle: number,
	cycleYear: number,
	duration: number
): IForecastByLevelCycleMonth[] {
	const months: IForecastByLevelCycleMonth[] = [];
	for (let i = 0; i < duration; i++) {
		const date = new Date(cycleYear, cycle + i, 1);
		const monthIdx = date.getMonth();
		const year = date.getFullYear();
		months.push({
			label: `${MONTH_NAMES_PT_BR[monthIdx]}/${year}`,
			dataFormatted: date.toISOString().split('T')[0],
			date,
		});
	}
	return months;
}

export function getMainFilterWidth(isExpanded: boolean): number {
	return isExpanded
		? PLANNING_CONSTANTS.UI.MAIN_FILTER.EXPANDED_WIDTH
		: PLANNING_CONSTANTS.UI.MAIN_FILTER.COLLAPSED_WIDTH;
}

export const buildFiltersPayload = ({
	cycleId,
	companyAreaId,
	filters,
	planningType,
	historyBase,
}: {
	cycleId?: number | string;
	companyAreaId?: number | string;
	filters?: IFilterHierarchy;
	planningType?: PlanningTypes;
	historyBase?: number;
}) => {
	const payload: any = {
		cycle_id: cycleId,
	};

	if (companyAreaId) payload.company_area_id = companyAreaId;
	if (filters?.commercialIds)
		payload.commercial_hierarchy_ids = filters.commercialIds;
	if (filters?.customerIds) payload.customer_ids = filters.customerIds;
	if (filters?.productIds) payload.product_ids = filters.productIds;
	if (planningType) payload.planning_type = planningType;
	if (historyBase) payload.history_base = historyBase;
	return payload;
};
